import styled from '@emotion/styled';

const Desc = styled.div`

`;

export default Desc;
